import { render, staticRenderFns } from "./mix-plan-placeholder.vue?vue&type=template&id=8a9de8f4&scoped=true"
import script from "./mix-plan-placeholder.vue?vue&type=script&setup=true&lang=js"
export * from "./mix-plan-placeholder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mix-plan-placeholder.vue?vue&type=style&index=0&id=8a9de8f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9de8f4",
  null
  
)

export default component.exports